import { Box, Flex, Text } from "@chakra-ui/react";

// Cột "Người tham gia giao dịch" ở Quản lý locking / Xác nhận HĐMB / Xác nhận TTKQ.
// value: field `participants` BE trả về,
// [{ fullName, interpretation (vai trò), jobPosition (chức vụ), jobTitle (chức danh) }]
export const ParticipantList = ({ value }) => {
  const participants = Array.isArray(value) ? value : [];

  if (!participants.length) {
    return <Text>-</Text>;
  }

  return (
    <Flex direction={"column"} gap={"6px"}>
      {participants.map((item, index) => (
        <Box key={index}>
          <Text
            fontSize={"14px"}
            lineHeight={"19.6px"}
            fontWeight={"500"}
            color={"var(--color-info-employee)"}
          >
            {`${item?.fullName || "-"} - ${item?.interpretation || "-"}`}
          </Text>
          <Text
            fontSize={"12px"}
            lineHeight={"16.8px"}
            fontWeight={"400"}
            color={"var(--color-label-employee)"}
          >
            {`Chức vụ: ${item?.jobPosition || "-"} | Chức danh: ${
              item?.jobTitle || "-"
            }`}
          </Text>
        </Box>
      ))}
    </Flex>
  );
};
